<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_wallet_banner.jpg')" alt="ウォレットについて">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="sup-page-title">
          ウォレットについて
        </h1>

        <p class="sup-page-lead">
          勝WINでは、各通貨ごとに独立したウォレットを採用しており、<br>
          お客様が簡単かつ効率的に資金を管理できるシステムとなっております。
        </p>

        <div class="sup-steps-box">
          <div class="sup-step">
            <p class="sup-step-num">
              ウォレットの利用・切り替え方法
            </p>
            <p class="sup-step-desc">
              利用・切り替え方法はとても簡単です・<br>
              「残高」を押し、利用したいウォレットを選択するだけで切り替えが可能です。
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_wallet_1.jpg')" alt="ウォレット切り替え画面1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_wallet_2.jpg')" alt="ウォレット切り替え画面2">
            </div>
          </div>
        </div>
        <div class="sup-wallet-index">
          <p class="sup-wallet-index-title">
            ウォレットの種類一覧
          </p>
          <div class="sup-wallet-index-list">
            <a class="sup-wallet-index-btn" href="#wallet-jpy">
              現金ウォレット（JPY）
              <span class="sup-wallet-index-arrow">⌄</span>
            </a>
            <a class="sup-wallet-index-btn" href="#wallet-crypto">
              仮想通貨ウォレット
              <span class="sup-wallet-index-arrow">⌄</span>
            </a>
            <a class="sup-wallet-index-btn" href="#wallet-bonus">
              BONUSウォレット
              <span class="sup-wallet-index-arrow">⌄</span>
            </a>
          </div>
        </div>
        <div id="wallet-jpy" class="sup-steps-box">
          <div class="sup-step">
            <p class="sup-step-num">
              現金ウォレット（JPY）
            </p>
            <div class="sup-content-list">
              <p class="sup-content-list-item">
                ・「JPYウォレット」は法定通貨（日本円）のウォレットです。
              </p>
              <p class="sup-content-list-item">
                ・銀行振込やeウォレットで入金した資金、またはBONUSウォレットの賭け条件を達成した資金は、「JPYウォレット」に反映されます。
              </p>
              <p class="sup-content-list-item">
                ・ボーナスを利用しない場合、出金条件は「入金額の2倍」です。
              </p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_wallet_3.jpg')" alt="現金ウォレット（JPY）">
            </div>
          </div>
        </div>
        <div id="wallet-crypto" class="sup-steps-box">
          <div class="sup-step">
            <p class="sup-step-num">
              仮想通貨ウォレット
            </p>
            <div class="sup-content-list">
              <p class="sup-content-list-item">
                ・「仮想通貨ウォレット」は、各通貨ごとに独立したウォレットを採用しています。
              </p>
              <p class="sup-content-list-item">
                ・仮想通貨で入金した場合は一切の両替は行われず、入金した通貨がそのまま対応するウォレットに反映され、プレイできます。
              </p>
              <p class="sup-content-list-item">
                ・ボーナスを利用しない場合、出金条件は「入金額の2倍」です。
              </p>
              <p class="sup-content-list-item">
                ・対応している仮想通貨は以下の通りです。
              </p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_wallet_4.jpg')" alt="仮想通貨ウォレット">
            </div>
          </div>
        </div>
        <div id="wallet-bonus" class="sup-steps-box">
          <div class="sup-step">
            <p class="sup-step-num">
              BONUSウォレット
            </p>
            <div class="sup-content-list">
              <p class="sup-content-list-item">
                ・入金不要ボーナスなど、プロモーションで獲得するボーナスは、「BONUSウォレット」に反映されます。
              </p>
              <p class="sup-content-list-item">
                ・「BONUSウォレット」の残高を利用する場合、特別な禁止ゲームやベット額制限、反映率が適用されます。詳細については、<a href="#" class="sup-text-link">プロモーション一般利用規約</a>をご参照ください。
              </p>
              <p class="sup-content-list-item">
                ・賭け条件はプロモーションによって異なり、条件達成後、残高は「JPYウォレット」へ自動的に移動され、出金が可能です。
              </p>
              <p class="sup-content-list-item">
                ・現金ウォレット（JPY）または仮想通貨ウォレットで入出金を行う時点で、BONUSウォレット内の残高が削除されますのでご注意ください。
              </p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_wallet_5.jpg')" alt="BONUSウォレット">
            </div>
          </div>
        </div>
        <hr class="sup-step-divider sup-section-divider">
        <p class="sup-step-num sup-section-title">
          ゲーム内の表示通貨
        </p>
        <div class="sup-content-list sup-content-list--section">
          <p class="sup-content-list-item">
            ・ゲームにアクセスする際に、ゲーム内に表示される通貨単位を「JPY」または「USD」から選択することができます。
          </p>
          <p class="sup-content-list-item">
            ・表示通貨はゲーム内の金額単位の表示のみを変更するものです。実際のベットや配当の受け取りは、選択しているウォレットの通貨で行われます。
          </p>
          <p class="sup-content-list-item">
            ・例）USDTウォレットを使用し、表示設定を「JPY」にした場合、ゲーム内ではJPY（円）でプレイしているように見えますが、USDTを使用して決済が行われています。
          </p>
          <p class="sup-content-list-item sup-text-red">
            ※ゲームプロバイダーによって、USD に対応していない場合があります。
          </p>
        </div>
        <div class="sup-step-img-wrap">
          <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_wallet_6.jpg')" alt="ゲーム内の表示通貨">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
